"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Image = _interopRequireDefault(require("./Image"));

exports.default = _Image.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/elements/Image/index.js
// module id = 107
// module chunks = 0